import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';
import Api from '@/data/Api.ts';
import { useMeterIssueTypeStore } from '@/stores/MeterIssueTypeStore.ts';

const URL_METER_ISSUE_SNOOZE =
  '/companies/{0}/plants/{1}/meters/{2}/issues/{3}/snooze';
const URL_METER_ISSUE_UNSNOOZE =
  '/companies/{0}/plants/{1}/meters/{2}/issues/{3}/unsnooze';
const URL_METER_ISSUE_GENERATE_PLANT_REPORT =
  '/companies/{0}/issues/generate-report';
const URL_METER_ISSUE_TYPES = '/meter-issue-types';

// Module-level so concurrent callers share one request even though each
// caller constructs its own MeterIssueApi instance.
let pendingTypesRequest: Promise<any> | null = null;

export default class MeterIssueApi extends Api {
  getAllTypes(): Promise<any> {
    const store = useMeterIssueTypeStore();
    if (store.isFresh()) {
      return Promise.resolve({ data: { data: store.types } });
    }
    if (pendingTypesRequest) {
      return pendingTypesRequest;
    }

    pendingTypesRequest = this.standardGet(URL_METER_ISSUE_TYPES, {}, [])
      .then((rsp) => {
        store.set(rsp.data.data);
        return rsp;
      })
      .finally(() => {
        pendingTypesRequest = null;
      });
    return pendingTypesRequest;
  }

  snooze(
    companyId: number,
    plantId: number,
    meterId: number,
    issueId: number,
    date: Date,
  ): Promise<any> {
    let url: string = StringUtils.stringFormat(URL_METER_ISSUE_SNOOZE, [
      companyId,
      plantId,
      meterId,
      issueId,
    ]);

    return this.standardPut(url, { snoozed_until: date });
  }

  unsnooze(
    companyId: number,
    plantId: number,
    meterId: number,
    issueId: number,
  ): Promise<any> {
    let url: string = StringUtils.stringFormat(URL_METER_ISSUE_UNSNOOZE, [
      companyId,
      plantId,
      meterId,
      issueId,
    ]);

    return this.standardPut(url, {});
  }

  generateReport(companyId: number, params = {}): Promise<any> {
    let url: string = StringUtils.stringFormat(
      URL_METER_ISSUE_GENERATE_PLANT_REPORT,
      [companyId],
    );
    return this.standardGet(url, params, []);
  }
}
